import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import utils from "../../../utils/utils";
import RadiologistApi from "../../../services/ApiServices/RadiologistApi";

const PatientListRow = ({ patient, handleClick }) => {
  const radsScore = {
    0: {
      border: "",
      text: "Incomplete",
      textColor: "",
      bgColor: "",
    },
    1: {
      border: "border-[#FFF]",
      text: "Negative",
      textColor: "text-[#FFF]",
      bgColor: "bg-white/10",
    },
    2: {
      border: "border-radsGreen",
      text: "LungRADS 2",
      textColor: "text-[#34C759]",
      bgColor: "bg-radsGreen",
    },
    3: {
      border: "border-radsYellow",
      text: "LungRADS 3",
      textColor: "text-radsYellow",
      bgColor: "bg-customYellow",
    },
    4: {
      border: "border-red-500",
      text: "LungRADS 4",
      textColor: "text-radsRed",
      bgColor: "bg-red-500/10",
    },
    "4a": {
      border: "border-red-500",
      text: "LungRADS 4",
      textColor: "text-radsRed",
      bgColor: "bg-red-500/10",
    },
    "4b": {
      border: "border-red-500",
      text: "LungRADS 4",
      textColor: "text-radsRed",
      bgColor: "bg-red-500/10",
    },
    "4x": {
      border: "border-red-500",
      text: "LungRADS 4",
      textColor: "text-radsRed",
      bgColor: "bg-red-500/10",
    },
    S: {
      border: "",
      text: "LungRADS S",
      textColor: "",
      bgColor: "",
    },
  };

  const [examCount, setExamCount] = useState(null);

  useEffect(() => {
    // debugger
    const fetchExamCount = async () => {
      try {
        const res = await RadiologistApi.getExamsCount(patient.patientID);
        setExamCount(res.data.examCount);
      } catch (error) {
        console.error("Failed to fetch exam count", error);
        setExamCount(0);
      }
    };

    if (patient.patientID) {
      fetchExamCount();
    }
  }, [patient.patientID]);

  const getAge = (birthYear) => {
    if (!birthYear) return "N/A";
    const parsedYear = parseInt(birthYear, 10);
    if (isNaN(parsedYear)) return "N/A";
    const currentYear = dayjs().year();
    return currentYear - parsedYear;
  };

  const {
    patientID,
    name,
    birthYear,
    lastExamStatus,
    latestFindingScore,
    lastExamId,
    aquisitionDate,
  } = patient || {};

  const examsArr = Array.isArray(patient?.exams) ? patient.exams : [];
  const pendingExam = examsArr.find((e) => e?.status === "pending");
  const topExam = pendingExam || examsArr[0];

  const _lastExamStatus = topExam?.status ?? lastExamStatus;
  const _latestFindingScore =
    typeof topExam?.findingScore !== "undefined"
      ? topExam.findingScore
      : latestFindingScore;
  const _aquisitionDate = topExam?.createdAt ?? aquisitionDate;

  const adjustedFindingScore =
    _latestFindingScore > 4 ? 4 : _latestFindingScore;
  const findings = _latestFindingScore > 0 ? "Yes" : "No";

  return (
    <div
      onClick={() => handleClick && handleClick(patientID)}
      className="rounded-[8px] w-[99%] h-[59px] min-h-[59px] bg-[#2B2B2B] pl-[30px] flex text-white items-center cursor-pointer">
      <div className="w-patientId">{utils.insertDash(patientID) ?? null}</div>
      <div className="w-fullName">{name}</div>
      <div className="w-age">{getAge(birthYear)}</div>
      <div className="w-status flex items-center gap-2">
        <div
          className={
            _lastExamStatus === "complete"
              ? "green-status-dot"
              : _lastExamStatus === "failed"
              ? "red-status-dot"
              : "yellow-status-dot"
          }
        ></div>
      
        {_lastExamStatus === "complete"
          ? "Complete"
          : _lastExamStatus === "failed"
          ? "Failed"
          : "Pending Analysis"}
      </div>

      <div className="w-findings">
        {_latestFindingScore}
        {/* <div
          className={`rounded-lg w-fit border h-fit text-[13px]
                    ${radsScore[adjustedFindingScore]?.border}
                    ${radsScore[adjustedFindingScore]?.bgColor}
                    ${radsScore[adjustedFindingScore]?.textColor}
                    p-[3px_10px_5px] box-border
                `}
        >
          {radsScore[adjustedFindingScore]?.text}
        </div> */}
      </div>
      <div className="w-previousCases">
        {examCount === null ? "Loading..." : examCount > 1 ? "Yes" : "No"}
      </div>
      <div className="w-aquisitionDate">
        {dayjs(_aquisitionDate).format("DD.MM.YYYY")}
      </div>
    </div>
  );
};

export default PatientListRow;
